import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = ({message}) => {
  return (
    <div className="loading-container py-4 d-flex flex-column align-items-center">
    <Spinner
      animation="border"
      size="lg"
      role="status"
      aria-hidden="true"
      className="pagespinner mb-2" // add margin-bottom
    />
    {message && (
      <p className="text-white text-center"><b>{message}</b></p>
    )}
  </div>
  
  );
};

export default Loader;
